<router-outlet>

</router-outlet>

<app-no-view *ngIf="shouldRenderComponent && !isIframe"></app-no-view>
